import { render } from "./GridDrepturiUtilizatori.vue?vue&type=template&id=3d800bc8&ts=true"
import script from "./GridDrepturiUtilizatori.vue?vue&type=script&lang=ts"
export * from "./GridDrepturiUtilizatori.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__